<div class="palantir-table-skeleton palantir-scrollbar">
  @for (item of [].constructor(10); track $index) {
    <div class="palantir-table-skeleton__row">
      <div class="palantir-table-skeleton__column">
        <palantir-skeleton style="height: 20px; width: 20px" />
      </div>

      @for (item of [].constructor(4); track $index) {
        <div class="palantir-table-skeleton__column">
          <palantir-skeleton style="height: 20px; width: 100%" />
        </div>
      }

      <div class="palantir-table-skeleton__column">
        <palantir-skeleton style="height: 20px; width: 20px" />
      </div>
    </div>
  }
</div>
